import { Extension } from "@tiptap/react";

const MPSLink = Extension.create({
  name: "mpsLink",

  addCommands() {
    return {
      // Insert an MPS deep link (Content or Survey)
      insertMPSLink:
        (options) =>
        ({ commands }) => {
          const { type, name, url, className } = options;

          if (!url || !name) {
            return false;
          }

          // Insert the link as HTML content at cursor position
          const linkHTML = `<a href="${url}" class="${className || 'content-link'}">${name}</a>`;
          return commands.insertContent(linkHTML);
        },
    };
  },
});

export default MPSLink;